import TextArea from "antd/lib/input/TextArea";
import { locale, t } from "../MainApp";

type CommentComponentProps = {
    comment: string;
    onChangeComment: (comment: string) => void;
    locale: locale;
};

export function CommentComponent(props: CommentComponentProps) {
    return (
        <TextArea rows={4} placeholder={t(props.locale, "pleaseEnterCommentPlaceholder")} allowClear={true} value={props.comment}
            onChange={event => {
                event.preventDefault();
                let targetValue = '';
                if (event.target.value) {
                    targetValue = event.target.value;
                }

                props.onChangeComment(targetValue);
            }}
        />
    );
}